if (!customElements.get('offers-drawer')) {
  class OffersDrawer extends BaseHTMLElement {
    constructor() {
      super();

      this.isLoaded = false;
      this.paramName = this.getAttribute('data-param-name');
      this.drawer = this.querySelector('custom-modal');
      this.show = debounce(this.show.bind(this), 50);
    }

    init() {
      if (this.paramName) {
        document.querySelectorAll(`a[href*="${this.paramName}="]`).forEach((opener) => {
          opener.addEventListener('click', (e) => {
            e.preventDefault();
            this.show();
          });
        });
      }
    }

    show() {
      this.load();
      requestAnimationFrame(() => {
        this.drawer.show();
      });
    }

    load() {
      if (this.isLoaded) {
        return;
      }

      Helpers.Sections.Fetch(['offers']).then((res) => {
        if (!res || !res.offers) {
          return;
        }

        const container = this.querySelector('.offers-drawer__offers');

        container.innerHTML = res.offers;

        this.classList.add('offers-drawer--loaded');
      });

      this.isLoaded = true;
    }
  }

  customElements.define('offers-drawer', OffersDrawer);
}
